module.exports = __webpack_public_path__ + "static/make-it-stick-book-8ed61b03a258508394405509057278f6.png";